import React, { useCallback, useState } from 'react';
import { PropTypes } from 'prop-types';
// styles
import styled, { css } from 'styled-components';
//
import SoFormPanel from 'refactored/features/soForm/components/layout/SoFormPanel';
import SoFormRowContainer from 'refactored/features/soForm/components/layout/SoFormRowContainer';
import SoFormPanelText from 'refactored/features/soForm/components/layout/SoFormPanelText';
import { GirdedQuestionIcon } from 'refactored/ui/icons';
import SoFormAddLoadButton from './SoFormAddLoadButton';
import SoFormLoadsType from './SoFormLoadsType';
import SoFormLoadsItems from './SoFormLoadsItems';
import SoFormLoadsSize from './SoFormLoadsSize';
import {
  useSoFormStepsApi,
  useSoFormStepsState,
} from 'refactored/features/soForm/SoForm.context';
import RemoveButton from 'refactored/ui/form/removeButton';
import LoadModal from 'refactored/features/order/loads/form/LoadModal';
import { useTranslation } from 'react-i18next';
import MaxLoadReached from './MaxLoadReached';

const LoadHeading = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0px;
  gap: 8px;

  height: 24px;
  /* border: 1px solid red; */
  width: 100%;
`;

const LoadSeparator = styled.div`
  width: 100%;
  height: 1px;
  background: var(--grey200);
  /* background: cyan; ; */
`;

const DeleteloadButton = styled.div`
  width: 20px;
  height: 20px;
  /* border: 1px solid black; */
`;

const LoadHeadingText = styled.div`
  height: 24px;

  /* 16px/medium */

  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  /* identical to box height, or 150% */

  /* grey / 800 */

  color: #3b4f63;
`;

const LoadsListContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0px;
  gap: 8px;

  flex: none;
  order: 1;
  align-self: stretch;
  flex-grow: 0;
  /* border: 5px solid green; */
`;

const LoadContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  padding: 8px 0px;

  /* height: 240px; */
  width: 100%;
  /* border: 5px solid red; */
`;

const SoFormLoads = ({ className }) => {
  const stepsState = useSoFormStepsState();
  const stepsApi = useSoFormStepsApi();
  const deleteLoad = useCallback(
    (load) => {
      stepsApi.deleteLoad(load);
    },
    [stepsApi]
  );
  const loads = stepsState.configuration.loads;
  const isMultiLoad = loads.length > 1;
  const { t } = useTranslation('LoadInfo');
  const { t: catalogT } = useTranslation('Catalog');

  const [showModal, setShowModal] = useState(false);

  let isMaxLoadReached = false;

  loads.forEach((load) => {
    if (load.number_of_items === load.maxLoads) isMaxLoadReached = true;
    else {
      isMaxLoadReached = false;
    }
  });

  return (
    <div className={className}>
      <SoFormPanel>
        <SoFormRowContainer>
          <SoFormPanelText>
            {catalogT('configuration.loads.header')}
          </SoFormPanelText>
          <GirdedQuestionIcon onClick={() => setShowModal(true)} />
        </SoFormRowContainer>
        <LoadsListContainer>
          {loads.map((load, index) => (
            <LoadContainer key={load.loadKey}>
              {isMultiLoad && (
                <>
                  {index > 0 && <LoadSeparator />}
                  <LoadHeading>
                    <LoadHeadingText>
                      {catalogT('configuration.loads.load')} {index + 1}{' '}
                    </LoadHeadingText>
                    <DeleteloadButton onClick={() => deleteLoad(load)}>
                      <RemoveButton handleRemove={() => deleteLoad(load)} />
                    </DeleteloadButton>
                  </LoadHeading>
                </>
              )}
              <SoFormLoadsType load={load} />
              <SoFormLoadsItems load={load} />
              <SoFormLoadsSize load={load} />
            </LoadContainer>
          ))}
        </LoadsListContainer>
        {isMaxLoadReached ? <MaxLoadReached /> : <SoFormAddLoadButton />}
      </SoFormPanel>
      <LoadModal t={t} showModal={showModal} setShowModal={setShowModal} />
    </div>
  );
};

SoFormLoads.propTypes = {
  className: PropTypes.string,
};

const regularCSS = css`
  display: flex;
  flex-direction: row;
  width: 100%;

  ${DeleteloadButton} button {
    height: 20px;
    width: 20px;
  }
  /* border: 5px solid black; */
`;

export default styled(SoFormLoads)`
  ${regularCSS}
`;
